function show_button_dann(form, type) {
  let productid = jQuery("#" + form).data("productid");
  var variantselects = new VariantSelects();
  let toid = 0;
  let curr_price_subs = 0;
  let currentVariant = jQuery("#" + form)
    .find(".js-main-hiddenInput")
    .val();
  let subs_Product_d = subs_Product[productid];
  jQuery.each(subs_Product_d.variant_to_duplicate, function (key, val) {
    if (key == currentVariant) {
      toid = val;
    }
  });
  jQuery.each(subs_Product_d.duplicate_to_price, function (key, val) {
    if (key == toid) {
      curr_price_subs = Shopify.formatMoney(val, "{{amount}}");
    }
  });
  var current_options_select = jQuery("#" + form)
    .find("#rc_duplicate_selector")
    .find(":selected")
    .data("from");

  let arrs = [];
  jQuery("#" + form)
    .find("variant-selects select option")
    .each(function () {
      if (jQuery(this).is(":selected")) {
        arrs.push(jQuery(this).val());
      }
    });
  let current_id_select = arrs.join(" / ");

  let no_active = 0;
  let no_found = 0;
  const productForm = document.getElementById(`${form}`);
  variantData =
    variantData ||
    JSON.parse(productForm.querySelector("#selectjson").textContent);

  jQuery.each(variantData, function (key, val) {
    if (val.title == current_id_select) {
      no_found++;
      if (val.available == true) {
        jQuery("#" + form)
          .find(".add-to-cart-button")
          .html(window.variantStrings.addToCart);
        jQuery("#" + form)
          .find(".add-to-cart-button")
          .attr("disabled", false);
      } else {
        jQuery("#" + form)
          .find(".add-to-cart-button")
          .html(window.variantStrings.unavailable);
        jQuery("#" + form)
          .find(".add-to-cart-button")
          .attr("disabled", true);
        no_active = 1;
      }
    }
  });
  if (no_found == 0) {
    jQuery("#" + form)
      .find(".add-to-cart-button")
      .html(window.variantStrings.unavailable);
    jQuery("#" + form)
      .find(".add-to-cart-button")
      .attr("disabled", true);
    no_active = 1;
  }

  if (type == "autodeliver") {
    if (curr_price_subs != 0) {
      if (no_active == 0) {
        jQuery("#" + form)
          .find(".add-to-cart-button")
          .html(window.variantStrings.addToCart);
        jQuery("#" + form)
          .find(".add-to-cart-button")
          .attr("disabled", false);
      }
    } else {
      jQuery("#" + form)
        .find(".add-to-cart-button")
        .html(window.variantStrings.unavailable);
      jQuery("#" + form)
        .find(".add-to-cart-button")
        .attr("disabled", true);
    }
  }
}

(function ($) {
  document.addEventListener("DOMContentLoaded", function () {
    //Product Gallery
    if ($(".product-imageslide .swiper-slide").length > 1) {
      document.querySelectorAll(".gallery-top").forEach((item) => {
        const sliderThumbs = new Swiper(
          item.nextElementSibling.firstElementChild,
          {
            direction: item.dataset.direction,
            slidesPerView: 4,
            spaceBetween: 10,
            freeMode: true,
            //noSwiping: false,
            breakpoints: {
              0: {
                direction: "horizontal",
              },
              769: {
                direction: item.dataset.direction,
              },
            },
          }
        );
        const sliderImages = new Swiper(item, {
          direction: item.dataset.direction,
          slidesPerView: 1,

          //loop:false,
          spaceBetween: 0,
          speed: 1000,
          //draggable: false,
          mousewheel: false,
          //allowTouchMove: false,
          grabCursor: true,
          //watchOverflow: true,
          thumbs: {
            swiper: sliderThumbs,
          },
          navigation: {
            nextEl:
              item.firstElementChild.nextElementSibling.nextElementSibling
                .firstElementChild,
            prevEl:
              item.firstElementChild.nextElementSibling.nextElementSibling
                .firstElementChild.nextElementSibling,
          },
          pagination: {
            el: item.firstElementChild.nextElementSibling.nextElementSibling
              .firstElementChild.nextElementSibling.nextElementSibling,
            clickable: true,
          },
          scrollbar: {
            el: item.firstElementChild.nextElementSibling,
          },
          breakpoints: {
            0: {
              direction: "horizontal",
              mousewheel: false,
            },
            769: {
              direction: item.dataset.direction,
            },
          },
        });
      });
    }
  });

  //Product Accordion
  $(".product__accordion details").on("click", function () {
    $(this)
      .parent()
      .siblings(".product__accordion")
      .find("details")
      .removeAttr("open");
  });

  //Subscribe widget custom chanes
  $(".rc_radio__onetime").on("change", function () {
    let form = $(this).data("form");
    $("#" + form + " .js-main-hiddenInput").attr("name", "id");
    $("#" + form + " .rc_duplicate_selector").attr("name", "");
    $("#" + form + " #curentvariant_autodeliver").val("");
    show_button_dann(form, "onetime");
  });
  $(".rc_radio__autodeliver").on("change", function () {
    let form = $(this).data("form");
    $("#" + form + " .js-main-hiddenInput").attr("name", "id");
    $("#" + form + " #rc_duplicate_selector").attr("name", "");

    let current_var = $("#" + form + " .js-main-hiddenInput").val();
    $("#" + form + "  #rc_duplicate_selector option").each(function (i) {
      let from = jQuery(this).data("from");
      if (from == current_var) {
        $("#" + form + " #curentvariant_autodeliver").val($(this).val());
      }
    });
    show_button_dann(form, "autodeliver");
  });
  $(".product_gallery_variant .left_nav").on("click", function () {
    $(".product_gallery_variant .left_nav").removeClass("active");
    $(".product_gallery_variant").addClass("remove");
  });

  if (location.href.includes("hairstyling-guide")) {
    console.log(location.href);
  } else {
    if ($(".product_gallery_variant img").length > 0) {
      $(".product_gallery_variant img").swipe(function () {
        $(".product_gallery_variant .left_nav").removeClass("active");
        $(".product_gallery_variant").addClass("remove");
      });
    }
  }

  $("select.select__select").on("change", function () {
    let option = $(this).data("option");
    // if (option == 'size') {
    let img = $(this).find(":selected").data("img");
    let imgsrcset = $(this).find(":selected").data("srcset");
    if (img != "") {
      $(".product_gallery_variant .var_prods_img").attr("src", img);
      $(".product_gallery_variant .var_prods_img").attr("srcset", imgsrcset);
      $(".product_gallery_variant").removeClass("remove");
      $(".product_gallery_variant").addClass("active");
      setTimeout(function () {
        $(".product_gallery_variant .left_nav").addClass("active");
      }, 1000);
    }
    let id = $(this).find(":selected").data("id");
    // }
  });

  //Product image popup
  $(".js-zoom-image").magnificPopup({
    type: "image",
    tLoading: "Loading image #%curr%...",
    mainClass: "mfp-img-mobile",
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
    },
    image: {},
    callbacks: {
      resize: function () {
        let heightLoadImg = this.content.find("img").height();
        this.content.find("img").addClass("smallSize");
        this.content.find("img").on("click", function () {
          if ($(this).hasClass("smallSize")) {
            $(this).css("max-height", "100%");
            $(this).removeClass("smallSize");
          } else {
            $(this).css("max-height", heightLoadImg);
            $(this).addClass("smallSize");
          }
        });
      },
      imageLoadComplete: function () {
        this.content.find("img").css("width", "auto");
      },
      change: function () {
        this.content.find("img").css("max-width", "auto");
      },
    },
  });
  //Product gallery popup
  $(".zoom-gallery").magnificPopup({
    type: "image",
    fixedContentPos: false,
    fixedBgPos: true,

    overflowY: "auto",
    removalDelay: 300, //delay removal by X to allow out-animation
    callbacks: {
      beforeOpen: function () {
        // just a hack that adds mfp-anim class to markup
        this.st.image.markup = this.st.image.markup.replace(
          "mfp-figure",
          "mfp-figure mfp-with-anim"
        );
        this.st.mainClass = "mfp-zoom-in";
      },
    },
    closeBtnInside: true,
    preloader: false,

    midClick: true,
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0, 1],
    },
  });

  //Product sticky button
  if ($(window).width() > 768) {
    $(window).on("scroll", function () {
      let bodyScroll = $(window).scrollTop(),
        navbar = $(".sticky-order-panel");

      if (bodyScroll > $(".product-form__buttons").offset().top + 30) {
        navbar.addClass("product_appear");
      } else {
        navbar.removeClass("product_appear");
      }
    });
    $(".close-stiky-order").on("click", function () {
      $(this).parent().addClass("hard_off_panel");
    });
  }
})(jQuery); //jQuery
